import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import Input from '../Input';
import Select from '../Select';

export default function AddEditCostsDialog({ open, onClose, editing, form, setForm, submitForm, options }) {
    return (
        <Dialog open={open} onClose={onClose} width="w-[500px]">
               <DialogTitle>{editing ? 'Edytuj koszt rozliczenia' : 'Dodaj koszt rozliczenia'}</DialogTitle>
               <DialogContent>
                 <div className="space-y-4 mt-2">
                   <div className="grid gap-2">
                     <Input size='small' label="Numer faktury" value={form.costTitle} placeholder='Tytuł faktury' onChange={e => setForm(v => ({ ...v, costTitle: e.target.value }))} fullWidth />
                   </div>
                   <div className="grid grid-cols-2 gap-2">
                     <Input size='small' label="Numer faktury" value={form.numberFV} placeholder='Numer faktury' onChange={e => setForm(v => ({ ...v, numberFV: e.target.value }))} fullWidth />
                     <Input size='small' type="number" label="Kwota" value={form.cost} placeholder='Kwota' onChange={e => setForm(v => ({ ...v, cost: e.target.value }))} fullWidth />
                   </div>
                   <div className="grid grid-cols-2 gap-2">
                     <Input size='small' type="date" label="Data" value={form.costDate || ""} placeholder='Data tranzakcji' onChange={e => setForm(v => ({ ...v, costDate: e.target.value }))} fullWidth />
                   <Select
         label="Kto zapłacił"
         value={form.costPaidBy ?? ''}
         onChange={e =>
           setForm(v => ({ ...v, costPaidBy: e.target.value }))
         }
         fullWidth
         options={(options?.users ?? []).map(u => ({
           value: u.id,
           label: u.us_name
         }))}
       />
                   </div>
                 </div>
               </DialogContent>
               <DialogActions>
                 <Button size='medium' onClick={() => onClose()} variant="outlined">Anuluj</Button>
                 <Button size='medium' onClick={submitForm} variant="contained" color='success'>Zapisz</Button>
               </DialogActions>
             </Dialog>
    );
}